module.exports = __webpack_public_path__ + "static/media/twojapogoda.5e4ea5de.jpg";